import React, { useEffect, useRef } from 'react'
import classnames from 'classnames'

import useStyles from './styles'

const FacebookSocialPostMedia = ({ mediaType, fileUrl }) => {
  const videoRef = useRef(null)

  const classes = useStyles()

  useEffect(() => {
    if (fileUrl && mediaType === 'video') {
      videoRef.current?.play()
    }
  }, [fileUrl, mediaType])

  return (
    <div className={classnames(classes.mediaPreview)}>
      {mediaType === 'image' ? (
        <img src={fileUrl} alt="Media preview" />
      ) : (
        <video ref={videoRef} src={fileUrl} autoPlay={true} loop={true} muted={true}>
          <source src={fileUrl} />
        </video>
      )}
    </div>
  )
}

export default FacebookSocialPostMedia
